export class DeleteEvent {
    id: string;
    name: string;
    type: string;

    getId(): string {
        return this.id;
    }

    setId(id: string): void {
        this.id = id;
    }

    setName(name: string) {
        this.name = name;
    }

    getName(): string {
        return this.name;
    }

    setType(type: string) {
        this.type = type;
    }

    getType() {
        return this.type;
    }
}
